import React, { createContext, useCallback, useState, useContext } from 'react';

export interface IOnlineContentConnector {
  userGuid?: string;
  sessionToken?: string;
  callbackUrl?: string;
  fqdn?: string;
  subdomain?: string;
  registrationNumber?: string;
  source?: string;
}

export interface OnlineContentConnectorCtx extends IOnlineContentConnector {
  updateData: (data: IOnlineContentConnector) => void;
}

const STATE = {
  updateData: () => {},
};

export const ONLINE_CONTENT_CONNECTOR_ATTRIBUTES = [
  'userGuid',
  'sessionToken',
  'callbackUrl',
  'fqdn',
  'subdomain',
  'registrationNumber',
  'source',
];

export const OnlineContentConnectorContext = createContext<OnlineContentConnectorCtx>(STATE);

export const useOnlineContentConnector = () => useContext(OnlineContentConnectorContext);
export const useIsOLCO = () => {
  const { userGuid } = useOnlineContentConnector();

  // checking connection is it online content connector
  return !!userGuid;
};

export const OnlineContentConnectorController = ({ children }) => {
  const [data, setData] = useState<IOnlineContentConnector>({});

  const updateData = useCallback((data: IOnlineContentConnector) => {
    setData((prevState) => ({ ...data, ...prevState }));
  }, []);

  return (
    <OnlineContentConnectorContext.Provider
      value={{
        ...data,
        updateData,
      }}
    >
      {children}
    </OnlineContentConnectorContext.Provider>
  );
};
